import { createFileRoute } from "@tanstack/react-router";

import { ArtigoForm } from "@/components/admin/ArtigoForm";

export const Route = createFileRoute("/admin/artigos/novo")({
  ssr: false,
  head: () => ({ meta: [{ title: "Novo artigo | Painel" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: Novo,
});

function Novo() {
  return <ArtigoForm artigo={null} />;
}
